<template>
  <svg
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    shape-rendering="crispEdges"
    class="w-full h-full"
    :class="{ 'olivia-animada': animated }"
    role="img"
    aria-label="Olivia, tu asistente"
  >
    <!-- Cuerpo del avatar (píxeles del mapa; los ojos van como overlay) -->
    <rect v-for="(c, i) in celdas" :key="i" :x="c.x" :y="c.y" width="1" height="1" :fill="c.fill" />

    <!-- Ojos abiertos -->
    <g class="olivia-ojos-abiertos">
      <rect v-for="(c, i) in ojosAbiertos" :key="'a' + i" :x="c.x" :y="c.y" width="1" height="1" :fill="c.fill" />
    </g>
    <!-- Ojos cerrados (línea): aparece un instante durante el parpadeo -->
    <g class="olivia-ojos-cerrados">
      <rect v-for="(c, i) in ojosCerrados" :key="'c' + i" :x="c.x" :y="c.y" width="1" height="1" :fill="c.fill" />
    </g>
  </svg>
</template>

<script setup>
defineProps({
  animated: { type: Boolean, default: false },
});

const COLORES = {
  G: '#8b9199', // gris
  D: '#5f6672', // gris oscuro (contorno interno / párpado)
  W: '#ffffff', // blanco
  P: '#ec9cb5', // rosa (nariz / interior orejas)
  E: '#9bbd4a', // verde (ojos)
  K: '#1f2937', // negro (pupila)
};

// Mapa de la carita (16x16). Los ojos NO están acá: se dibujan como overlay
// para poder parpadear (se ocultan y aparece la línea gris de abajo).
const MAPA = [
  '..GG........GG..',
  '.GDDG......GDDG.',
  '.GDPG......GPDG.',
  '.GDDGGGGGGGGDDG.',
  '.GGGGGGGGGGGGGG.',
  'GGGGGGGGGGGGGGGG',
  'GGGGGGGGGGGGGGGG',
  'GGGGGGGGGGGGGGGG',
  'GGGGGGGWWGGGGGGG',
  'GGGGGWWWWWWGGGGG',
  'GGGWWWWPPWWWWGGG',
  '.GWWWWWWWWWWWWG.',
  '.GWWWWWWWWWWWWG.',
  '..GWWWWWWWWWWG..',
  '...GGWWWWWWGG...',
  '.....GGGGGG.....',
];

const celdas = [];
MAPA.forEach((row, y) => {
  [...row].forEach((ch, x) => {
    if (COLORES[ch]) celdas.push({ x, y, fill: COLORES[ch] });
  });
});

// Ojos abiertos (verdes con pupila) sobre la cara gris (filas 6-7)
const ojosAbiertos = [
  { x: 3, y: 6, fill: COLORES.E }, { x: 4, y: 6, fill: COLORES.E },
  { x: 11, y: 6, fill: COLORES.E }, { x: 12, y: 6, fill: COLORES.E },
  { x: 3, y: 7, fill: COLORES.E }, { x: 4, y: 7, fill: COLORES.K },
  { x: 11, y: 7, fill: COLORES.K }, { x: 12, y: 7, fill: COLORES.E },
];

// Ojos cerrados: una línea gris oscura en la fila baja del ojo
const ojosCerrados = [
  { x: 3, y: 7, fill: COLORES.D }, { x: 4, y: 7, fill: COLORES.D },
  { x: 11, y: 7, fill: COLORES.D }, { x: 12, y: 7, fill: COLORES.D },
];
</script>

<style scoped>
/* Los ojos cerrados están ocultos salvo durante el parpadeo */
.olivia-ojos-cerrados { opacity: 0; }

/* Parpadeo pixel art: cambio instantáneo (steps), no fundido */
.olivia-animada .olivia-ojos-abiertos {
  animation: olivia-abre 5s steps(1, end) infinite;
}
.olivia-animada .olivia-ojos-cerrados {
  animation: olivia-cierra 5s steps(1, end) infinite;
}
@keyframes olivia-abre {
  0%, 92%, 100% { opacity: 1; }
  94%, 98% { opacity: 0; }
}
@keyframes olivia-cierra {
  0%, 92%, 100% { opacity: 0; }
  94%, 98% { opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .olivia-animada .olivia-ojos-abiertos,
  .olivia-animada .olivia-ojos-cerrados { animation: none; }
  .olivia-ojos-abiertos { opacity: 1; }
  .olivia-ojos-cerrados { opacity: 0; }
}
</style>
